// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__amAfa","image":"Header_image__3qL_d","name":"Header_name__1km6Y","info":"Header_info__1DaXU","infoRow":"Header_infoRow__3aQE6"};